"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StructuredDocumentDestination = void 0;
var tslib_1 = require("tslib");
var destination_1 = require("./destination");
var structured_document_content_destination_1 = require("./structured-document-content-destination");
var StructuredDocumentDestination = (function (_super) {
    tslib_1.__extends(StructuredDocumentDestination, _super);
    function StructuredDocumentDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StructuredDocumentDestination.prototype.processCurrentElement = function (reader) {
        return reader.localName == 'sdtContent' ? new structured_document_content_destination_1.StructuredDocumentContentDestination(this.data) : _super.prototype.processCurrentElement.call(this, reader);
    };
    return StructuredDocumentDestination;
}(destination_1.TransparentDestination));
exports.StructuredDocumentDestination = StructuredDocumentDestination;
